import React from "react";
import { observer } from "mobx-react";
import LoginForm from "./components/authentication/LoginForm";
import UserStore from "./stores/UserStore";
import NavBar from "./components/navigation/NavBar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "react-widgets/dist/css/react-widgets.css";
import "./App.css";
import ProtectedRoute from "./components/navigation/ProtectedRoute";
import Profile from "./components/pages/Profile";
import Forgot from "./components/pages/Forgot";
import Reset from "./components/pages/Reset";
import AccountManager from "./components/pages/AccountManager";
import LinkBox from "./components/common/linkBox";
import { Alert } from "./components/common/Alert";
import ATTCNBD from "./components/pages/ATTCNBDPage";
import NotFound from "./components/pages/NotFound";
import Can from "./components/authentication/Can";

class App extends React.Component {
  async componentDidMount() {
    try {
      let res = await fetch("/isLoggedIn", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();

      if (result && result.success) {
        UserStore.loading = false;
        UserStore.isLoggedIn = true;
        UserStore.username = result.username;
        UserStore.permissions = result.permissions;
      } else {
        UserStore.loading = false;
        UserStore.isLoggedIn = false;
        UserStore.permissions = [{ name: "visitor" }];
      }
    } catch (e) {
      UserStore.loading = false;
      UserStore.isLoggedIn = false;
      UserStore.permissions = [{ name: "visitor" }];
      console.log(e);
    }
  }

  render() {
    if (UserStore.loading) {
      return (
        <div className="app">
          <div className="container">
            <p>Loading, please wait..</p>
          </div>
        </div>
      );
    } else {
      return (
        <Router>
          <NavBar showATTCNBDNav={UserStore.isLoggedIn} />
          <Switch>
            
            <Route path="/login" exact component={LoginForm} />
            <Route path="/forgot" exact component={Forgot} />
            <Route path="/reset" exact component={Reset} />
            <Route path="/reset/:token" component={Reset} />
            <Route
              path="/"
              exact
              render={(props) =>
                UserStore.isLoggedIn ? (
                  <ATTCNBD {...props} />
                ) : (
                  <LoginForm {...props} />
                )
              }
            />
            <ProtectedRoute
              path="/profile"
              exact
              pageName="profile"
              component={Profile}
            />
            <ProtectedRoute
              path="/att-cnbd"
              exact
              pageName="att-cnbd"
              component={ATTCNBD}
            />
            <Can
              role={UserStore.permissions}
              perform="account-manager:visit"
              yes={() => (
                <ProtectedRoute
                  path="/acctmgr"
                  exact
                  pageName="account-manager"
                  component={AccountManager}
                />
              )}
              no={() => (
                <></>
              )} 
            />
            <Route component={NotFound} />
          </Switch>
          <div className="alertArea">
            <Alert />
          </div>
        </Router>
      );
    }
  }
}

export default observer(App);
